<img *ngIf="!isImageBroken; else brokenImage" class="image-container" src="{{ _src }}" (error)="setBrokenImage()" />
<ng-template #brokenImage>
  <div class="image-container">
    <img src="assets/shared/camera.png" />
  </div>
</ng-template>
